import React from 'react';

import { ReactComponent as LoginIcon } from 'applicaiton/assets/login.svg';

import { ImageContentWrapper, ImageAuth } from './styles';

/**
 * AuthImage Component
 *
 * @description A React functional component that renders an SVG image with a border radius of 0.
 */
const AuthImage = () => {
  return (
    <ImageContentWrapper>
      <ImageAuth borderRadius={'0'}>
        <LoginIcon />
      </ImageAuth>
    </ImageContentWrapper>
  );
};

export default AuthImage;
